/* eslint-disable @typescript-eslint/naming-convention */
'use client';

import { Logo } from '@gds/Logo/Logo';
import { Typography } from '@gds/Typography/Typography';
import { getFormattedDate } from '@intl/GetFormattedDate';

import LeasingPrice from 'Components/VehicleAttributes/LeasingPrice/LeasingPrice';

import type { LeasingVehicleAttributesProps } from './LeasingVehicleAttributes.entity';

import styles from './LeasingVehicleAttributes.module.css';

export const LeasingVehicleAttributes = ({
  locale,
  vehicle,
  strings,
}: LeasingVehicleAttributesProps) => {
  const { prettyName, variant, spec, ukLeasingOptions } = vehicle;

  const leasingPrice = ukLeasingOptions?.[0];

  const term = leasingPrice?.term;
  const annualMileage = leasingPrice?.annualMileage;
  const orderedBy = leasingPrice?.orderedBy;

  return (
    <div className={styles.attributeWrapperSidebar}>
      <div className={styles.makeModelNameWrapper}>
        <Typography variant="h4" className={styles.vehiclePrettyName}>
          {prettyName}
        </Typography>
        <Typography className={styles.vehicleVariantName}>
          {variant?.label || spec.display}
        </Typography>
      </div>
      <div className={styles.leasingRateWrapper}>
        <div className={styles.priceWrapper}>
          {leasingPrice && (
            <LeasingPrice locale={locale} leasingPrice={leasingPrice} strings={strings} />
          )}
        </div>
      </div>
      <div className={styles.contactDisclaimer}>
        <Typography Component="span" variant="caption5">
          *{term} {strings.leasingMonths} {annualMileage} {strings.leasingTerms}{' '}
          {strings.leasingOrder} {getFormattedDate(orderedBy, locale)}. {''}
          {strings.vwfs}
        </Typography>
      </div>

      <div className={styles.contact}>
        <Typography Component="span" variant="body2">
          {strings.leasingInterestQuestion}
        </Typography>
        <Typography Component="span" variant="body4" className={styles.logo}>
          {strings.leasingInterestContact} <Logo usage="light_bg" fontSize={80} />
        </Typography>
      </div>
    </div>
  );
};
